import React, { useContext, useEffect, useRef, useState } from "react"
import { Container, Table, Button, Row, Col } from "reactstrap"
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial"
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner"
import Header from "../../components/Headers/Header"
import AdminNavbar from "../../components/Navbars/AdminNavbar/AdminNavbar"
import "./UserType.css"
import { AuthContext } from "../../context/AuthContext"
import { TipoAgendaContext } from "../../context/TipoAgendaContext"
import { TipoAgendaType, UpdateTipoAgendaType } from "../../context/hooks/useTipoAgenda"
import useUser from "../../context/hooks/useUser"

import CreateTipoAgendaModal from "../../components/TipoAgenda/CreateTipoAgendaModal"
import EditTipoAgendaModal from "../../components/TipoAgenda/EditTipoAgendaModal"

const PAGE_SIZE = 9

const TipoAgenda = () => {
    const { objUserTk } = useContext(AuthContext)
    const { listTipoAgenda, agendaPageCount, getAllTipoAgendaPaged, deleteTipoAgenda } =
        useContext(TipoAgendaContext)

    const { getPermissionsByUser, userPermissions } = useUser()

    const [selectedTipoAgendaId, setSelectedTipoAgendaId] = useState(0)
    const [editingTipoAgenda, setEditingTipoAgenda] = useState<UpdateTipoAgendaType | null>(null)
    const [createModalOpen, setCreateModalOpen] = useState(false)
    const [editModalOpen, setEditModalOpen] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)

    // trava para impedir múltiplos fetches concorrentes (evita “pisca” do loading global)
    const fetchLockRef = useRef(false)
    const aliveRef = useRef(true)

    const fetchPage = async (page: number) => {
        if (!objUserTk?.EmpresaId) return
        if (fetchLockRef.current) return

        fetchLockRef.current = true
        try {
            await getAllTipoAgendaPaged(page, PAGE_SIZE, objUserTk.EmpresaId)
            if (aliveRef.current) setCurrentPage(page)
        } finally {
            fetchLockRef.current = false
        }
    }

    useEffect(() => {
        aliveRef.current = true

            ; (async () => {
                try {
                    // 1) carrega lista primeiro
                    await fetchPage(1)

                    // 2) depois permissões (sequencial => evita corrida no loading global)
                    if (objUserTk?.UserId) {
                        await getPermissionsByUser(objUserTk.UserId)
                    }
                } catch (e) {
                    console.error("Erro no bootstrap TipoAgenda:", e)
                }
            })()

        return () => {
            aliveRef.current = false
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [objUserTk?.EmpresaId, objUserTk?.UserId])

    const onChangePaginationCommon = async (_e: any, value: any) => {
        const page = Number(value) || 1
        await fetchPage(page)
    }

    const handleEditTipoAgenda = (tipoAgenda: TipoAgendaType) => {
        setEditingTipoAgenda(tipoAgenda)
        setSelectedTipoAgendaId(tipoAgenda.id)
        setEditModalOpen(true)
    }

    const handleDeleteTipoAgenda = async (tipoAgendaId: number) => {
        if (!window.confirm("Tem certeza que deseja excluir este tipo de agenda?")) return

        try {
            await deleteTipoAgenda(tipoAgendaId)
            // refresh UMA vez, na página atual
            await fetchPage(currentPage)
        } catch (error) {
            console.error("Erro ao excluir tipo de agenda:", error)
        }
    }

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar brandText={"Tipos de Agenda"} search={false} titleSearch={""} />

            <Container className="mt-5">
                <Row className="align-items-center mb-4">
                    {userPermissions.includes(1) && (
                        <Col xs="12" className="text-right mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                className="btn-filter"
                                onClick={() => setCreateModalOpen(true)}
                            >
                                Adicionar tipo de agenda
                            </Button>
                        </Col>
                    )}
                </Row>

                {userPermissions.includes(2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped custom-table">
                                <thead>
                                    <tr>
                                        <th>Sequência</th>
                                        <th>Descrição</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listTipoAgenda.map((tipoAgenda: TipoAgendaType) => (
                                        <tr key={tipoAgenda.id}>
                                            <td>{tipoAgenda.id}</td>
                                            <td>{tipoAgenda.description}</td>
                                            <td>
                                                {userPermissions.includes(3) && (
                                                    <Button onClick={() => handleEditTipoAgenda(tipoAgenda)}>
                                                        <i className="fa-solid fa-pen-to-square"></i>
                                                    </Button>
                                                )}
                                                {userPermissions.includes(4) && (
                                                    <Button onClick={() => handleDeleteTipoAgenda(tipoAgenda.id)} color="danger">
                                                        <i className="fa-solid fa-trash"></i>
                                                    </Button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                            <div className="d-flex justify-content-end mt-3">
                                {agendaPageCount ? (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial onChange={onChangePaginationCommon} count={agendaPageCount} />
                                    </div>
                                ) : null}

                                {listTipoAgenda.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar os tipos de agenda.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <CreateTipoAgendaModal
                isOpen={createModalOpen}
                toggle={() => setCreateModalOpen(false)}
                onCreated={() => fetchPage(currentPage)}
            />

            <EditTipoAgendaModal
                isOpen={editModalOpen}
                toggle={() => setEditModalOpen(false)}
                tipoAgenda={editingTipoAgenda}
                onUpdated={() => fetchPage(currentPage)}
                onDeleted={() => fetchPage(currentPage)}
            />
        </>
    )
}

export default TipoAgenda